import React, {useEffect, useState} from "react";
import SideBar from "../../../../common/SideBar";
import NavBar from "../../../../common/NavBar";
import Spinner from 'reactjs-simple-spinner';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Link, useHistory} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import AgentService from "../../../../services/AgentService";
import FilesService from "../../../../services/FilesService";
import SavingsService from "../../../../services/SavingsService";
import InputMask from "react-input-mask";
import SavingsPolicyService from "../../../../services/SavingsPolicyService";
import moment from "moment";
import DatePicker from "react-modern-calendar-datepicker";
import ProductPackagesServices from "../../../../services/ProductPackagesServices";
import ProductsService from "../../../../services/ProductsService";
import SettingsService from "../../../../services/SettingsService";

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '100%'
    },
    root: {
        width: '100%',
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    actionsContainer: {
        marginBottom: theme.spacing(2),
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: '100%',
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const AllocateSavingsPolicy = () => {
    let history = useHistory();

    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();
    const [agents, setAgents] = useState([]);
    const [policyHolderId, setPolicyHolderId] = useState('');
    const [products, setProducts] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [newProduct, setNewProduct] = useState({});
    const [loading, setLoading] = useState(false);
    const [loadingPolicy, setLoadingPolicy] = useState(false);
    const [uploadLoading, setUploadLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(false);
    const [productsLoading, setProductsLoading] = useState(false);
    const [uploadDeductionLoading, setUploadDeductionLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [deductionMessage, setDeductionMessage] = useState('');
    const [filename, setFilename] = useState('');
    const [deductionFilename, setDeductionFilename] = useState('');
    const [policy, setPolicy] = useState({});
    const [showBankDetails, setShowBankDetails] = useState(false);
    const [showMobileDetails, setShowMobileDetails] = useState(false);
    const [commencementDate, setCommencementDate] = useState(null);

    const [industries, setIndustries] = useState([])
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleAdd = () => {
        setLoading(true);
        console.log(newProduct);
        const data = {
            'product_id': productId,
            'monthly_investments_premium': newProduct.monthly_investments_premium,
            'clawback_period': 2
        }
        console.log("data: ", data);
        ProductPackagesServices.addProductPackage(data)
            .then(res => {
                console.log(res);
                if(res.status === 200){
                    SavingsService.getAllSavingsProducts(productId)
                        .then(response => {
                            console.log("products: ", response.data.packages);
                            setProducts(response.data.packages);
                        setLoading(false);
                        toast('Cover Added Successfully', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        handleClose();
                    }).catch(err => {
                        console.log(err);
                        setLoading(false);
                         toast.warning('Failed To Add Cover', {
                             position: "top-right",
                             autoClose: 3000,
                             hideProgressBar: false,
                             closeOnClick: true,
                             pauseOnHover: true,
                             draggable: true,
                             progress: undefined,
                         });
                        handleClose();
                    })
                } else if (res.status === 400) {
                    setLoading(false);
                    toast.warning('Wrong inputs! Please verify your details', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else {
                    setLoading(false);
                    toast.warning('Failed To Add Cover', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    handleClose();
                }
            })
            .catch(err => {
                console.log(err);
                setLoading(false);
                toast.warning('Operation Failed, Error:' + err, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                handleClose();
            });

    }

    const handleFileChange = (e) => {
        setUploadLoading(true);
        console.log("e: ", e.target.name);
        console.log(e.target.files);
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append( e.target.name,file);
        FilesService.savingsUploadFile(formData,policyHolderId)
            .then(res => {
                console.log(res);
                setUploadLoading(false);
                setMessage(res.data.application_form);
                setFilename(res.data.application_form);
                setPolicy({...policy,'application_form': res.data.application_form})
            })
            .catch(err => {
                setUploadLoading(false);
                setMessage('');
                console.log(err);
            });
    }

    const handleDeductionFileChange = (e) => {
        setUploadDeductionLoading(true);
        console.log("e: ", e.target.name);
        console.log(e.target.files);
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append( e.target.name,file);
        FilesService.savingsUploadFile(formData,policyHolderId)
            .then(res => {
                console.log(res);
                setUploadDeductionLoading(false);
                setDeductionMessage(res.data.deduction_form);
                setDeductionFilename(res.data.deduction_form);
                setPolicy({...policy,'deduction_form': res.data.deduction_form})
            })
            .catch(err => {
                setUploadDeductionLoading(false);
                setDeductionMessage('');
                console.log(err);
            });
    }

    const handleChangeNew = name => ({ target: { value } }) => {
        setNewProduct({ ...newProduct, [name]: value })
    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    const classes = useStyles();

    /**
     * stepper form
     */

    function getSteps() {
        return ['General Details','Financial Details','Documents'];
    }

    function getStepContent(step) {
        switch (step) {
            case 0:
                return (
                    <div>
                        <div>
                            <h4 className="text-black-50">General Details</h4>
                        </div>
                        <hr/>
                        <div className="form-row" id="accidentPackagesTable">
                            <div className="form-group col-md-12 table-wrapper">
                                <label>Select Cover</label>&nbsp;&nbsp;|&nbsp;
                                <button className="btn btn-primary btn-link" type="button" onClick={handleClickOpen}>
                                    <i className="fa fa-plus"/>&nbsp;&nbsp;Add new
                                    cover.
                                </button>
                                <Dialog  maxWidth="sm" open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                                    {loading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="medium"
                                                message="Please wait while new cover is created..."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>

                                    )}
                                    {!loading && (
                                        <div>
                                            <DialogTitle id="form-dialog-title">Add New Cover</DialogTitle>
                                            <DialogContent>

                                                <DialogContentText>
                                                    Fill in Details
                                                </DialogContentText>

                                                <TextField
                                                    id="premium"
                                                    label="Monthly Investment Premium"
                                                    type="number"
                                                    placeholder="0"
                                                    fullWidth
                                                    onChange={handleChangeNew('monthly_investments_premium')}
                                                />
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={handleClose} color="primary">
                                                    Cancel
                                                </Button>
                                                <Button onClick={handleAdd} color="primary">
                                                    Add Cover
                                                </Button>
                                            </DialogActions>
                                        </div>
                                    )}
                                </Dialog>
                                <div className="scroll-table">
                                    {productsLoading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="medium"
                                                message="Please wait getting packages..."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>

                                    )}
                                    {!productsLoading && (
                                        <table className="table">
                                            <tr>
                                                <th>Monthly Investment Premium</th>
                                                <th>Select One</th>
                                            </tr>
                                            <tbody id="accidentPackages">
                                            {products.map((a, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td>{a.monthly_investments_premium}</td>
                                                    {/*<td>{a.clawback_period} months</td>*/}
                                                    <td>
                                                        <div className="form-check-label">
                                                            <input
                                                                type="radio"
                                                                name="savingsProductId"
                                                                onChange={handleChangePolicyProduct('savingsProductId')}
                                                                value={JSON.stringify(a)}
                                                            />
                                                        </div>
                                                    </td>
                                                    </tr>
                                                )
                                            })}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="p-2"/>

                        <div className="form-row">
                            <div className="form-group col-md-5">
                                <label htmlFor="inputFirstName">
                                    <span className="text-danger">*</span><strong>SELECT SALES ARMY </strong>
                                </label>

                                <select className="form-control" name="agentId" onChange={handleChange('agentId')}>
                                    <option selected disabled>Select Agent</option>
                                    {agents.map((a, i) => {
                                        return (
                                            <option key={i} value={parseInt(a.id)}>{a.name}&nbsp;{a.surname}</option>
                                        )
                                    })}
                                </select>
                            </div>
                            <div className="form-group col-md-2">

                            </div>

                            <div className="form-group col-md-5">
                                <label htmlFor="inputFirstName">
                                    <span className="text-danger">*</span>
                                    <strong>COMMENCEMENT DATE</strong>
                                </label>
                                <br/>

                                <DatePicker
                                    value={commencementDate}
                                    onChange={setCommencementDate}

                                    minimumDate={commencementDate}
                                    inputPlaceholder="Select Date"

                                />
                                <br/>
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group col-md-4">
                                <label htmlFor="inputFirstName">
                                    <span className="text-danger">*</span><strong>Industry</strong>
                                </label>

                                <select className="form-control" name="industry" onChange={handleChange('industry')}>
                                    <option selected disabled>Select Industry</option>
                                    {industries.map((a, i) => {
                                        return (
                                            <option key={i} value={a.name}>{a.name}</option>
                                        )
                                    })}
                                </select>
                            </div>
                            <div className="form-group col-md-4">
                                <label htmlFor="inputFirstName">
                                    <span className="text-danger">*</span><strong>Preferred Currency</strong>
                                </label>

                                <select className="form-control" name="currency"
                                        onChange={handleChange('currency')}>
                                    <option selected disabled>Select Currency</option>
                                    <option value="USD">USD</option>
                                    <option value="ZWL">ZWL</option>
                                </select>
                            </div>
                        </div>

                    </div>
                );
            case 1:
                return (
                    <div>
                        <div>
                            <h4 className="text-black-50">Financial Details</h4>
                        </div>
                        <hr/>
                        <div className="p-3"/>
                        <div className="form-row">
                            <div className="form-group col-md-4" style={{marginTop: -8}}>
                                <label><span className="text-danger">*</span>Premium Payer Options</label>
                                <select
                                    className="form-control"
                                    name="premiumPayer"
                                    onChange={handleChange('premiumPayer')}
                                >
                                    <option value>Select Options</option>
                                    <option value="MAIN_LIFE_ASSURED">Main Life Assured</option>
                                    <option value="PREMIUM_PAYER">Premium Payer</option>
                                    <option value="MAIN_LIFE_ASSURED_&_PREMIUM_PAYER">
                                        Main Life Assured & Premium Payer
                                    </option>
                                </select>
                                <p className="message">
                                    {/*{{ validation.firstError("premiumPayer") }}*/}
                                </p>
                            </div>
                            <div className="form-group col-md-4" style={{marginTop: -8}}>
                                <label><span className="text-danger">*</span>Payment Frequency</label>
                                <select
                                    className="form-control"
                                    name="paymentFrequency"
                                    onChange={handleChange('paymentFrequency')}
                                >
                                    <option value>Select Frequency</option>
                                    <option value="MONTHLY">MONTHLY</option>
                                    <option value="QUARTERLY">QUARTERLY</option>
                                    <option value="SEMI_ANNUALLY">SEMI ANNUALLY</option>
                                    <option value="ANNUALLY">ANNUALLY</option>
                                </select>
                                <p className="message">
                                    {/*{{ validation.firstError("premiumPayer") }}*/}
                                </p>
                            </div>
                            <div className="form-group col-md-4" style={{marginTop: -8}}>
                                <label><span className="text-danger">*</span>Payment Method</label>
                                <select
                                    className="form-control"
                                    name="paymentMethod"
                                    onChange={handleChange('paymentMethod')}
                                >
                                    <option value>Select Method</option>
                                    <option value="CASH">CASH</option>
                                    <option value="DEBIT_ORDER">DEBIT ORDER</option>
                                    <option value="STOP_ORDER">STOP ORDER</option>
                                </select>
                                <p className="message">
                                    {/*{{ validation.firstError("premiumPayer") }}*/}
                                </p>
                            </div>
                        </div>
                        {showBankDetails && (
                        <div className="form-row">
                            <div className="form-group col-md-12">
                                <label>
                                    <strong>Bank Details</strong>
                                </label>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="inputFirstName">
                                    <span className="text-danger">*</span>Bank Name
                                </label>
                                <TextField
                                    id="bankName"
                                    name="bankName"
                                    type="text"
                                    onChange={handleChange('bankName')}
                                    className={classes.textField}
                                />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="inputFirstName">
                                    <span className="text-danger">*</span> Branch Name
                                </label>
                                <TextField
                                    id="branchName"
                                    name="branchName"
                                    type="text"
                                    onChange={handleChange('branch')}
                                    className={classes.textField}
                                />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="inputFirstName">
                                    <span className="text-danger">*</span>Account Name
                                </label>
                                <TextField
                                    id="accountName"
                                    name="accountName"
                                    type="text"
                                    onChange={handleChange('accountName')}
                                    className={classes.textField}
                                />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="inputFirstName">
                                    <span className="text-danger">*</span>Account Number
                                </label>
                                <TextField
                                    id="accountNumber"
                                    name="accountNumber"
                                    type="number"
                                    onChange={handleChange('accountNumber')}
                                    className={classes.textField}
                                />
                            </div>

                        </div>
                        )}
                        <div className="p-3" />
                        {showMobileDetails && (
                        <div className="form-row mb-4">
                            <div className="form-group col-md-12">
                                <label>
                                    <strong>Mobile Details</strong>
                                </label>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="inputFirstName">
                                    <span className="text-danger">*</span>Mobile Account Name
                                </label>
                                <TextField
                                    id="mobileAccountName"
                                    select
                                    name="mobileAccountName"
                                    type="text"
                                    onChange={handleChange('mobileAccountName')}
                                    className={classes.textField}
                                    helperText="Please select provider"
                                >
                                    <MenuItem value="ECOCASH">
                                        EcoCASH
                                    </MenuItem>
                                    <MenuItem value="TELECASH">
                                        TeleCASH
                                    </MenuItem>
                                    <MenuItem value="ONE_MONEY">
                                        OneMoney
                                    </MenuItem>
                                </TextField>
                            </div>

                            <div className="col-md-6">
                                <label htmlFor="inputFirstName">
                                    <span className="text-danger">*</span>Mobile Number
                                </label>
                                <InputMask mask="0999999999"
                                           className="form-control" maskChar={null} name="mobileNumber"
                                           onChange={handleChange('mobileNumber')}/>
                            </div>
                        </div>
                        )}
                    </div>
                )
            case 2:
                return (
                    <div id="area2">
                        <div>
                            <h4 className="text-black-50">Documents</h4>
                        </div>
                        <hr/>
                        <div className="p-3"/>
                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <label htmlFor="inputEmail4"><span className="text-muted small">(Optional)&nbsp;</span>
                                    Upload Application Form</label>
                                <br/>
                                <em className="text-muted">* You can select file to upload</em>
                                &nbsp;&nbsp;
                                {/*<span style={{display: "none"}} id="uploadingLoader"/>*/}
                                {uploadLoading && (
                                    <div className="mt-2 mb-2 p-1">
                                        <Spinner
                                            size="small"
                                            message="Uploading File....."
                                            line-fg-color="#64c3c2"
                                        />
                                    </div>

                                )}
                                {message !== '' && !uploadLoading && (
                                    <span className="text-success">
                                        <br/>File Saved&nbsp;<i className="fa fa-check" />
                                    </span>
                                )}
                                <div>
                                    {message === '' && !uploadLoading && (
                                        <label className="btn btn-sm btn-primary" htmlFor="my-file-selector1">
                                            <input required
                                                   id="my-file-selector1"
                                                   type="file"
                                                   name="application_form"
                                                   style={{display: "none"}}
                                                   accept=".pdf, .docx, .doc"
                                                   onChange={handleFileChange}
                                            />
                                            <i className="fa fa-folder-open"/>&nbsp;&nbsp;
                                            Browse
                                        </label>
                                    )}
                                    <div className="p-3"/>
                                    {message && (
                                        <span className="form-control" id="upload-file-info" disabled>{message}</span>
                                    )}
                                </div>
                            </div>
                            <div className="form-group col-md-6">
                                <label htmlFor="inputEmail4">
                                    <span className="text-muted small">(Optional)&nbsp;</span>
                                    Upload Deduction Form</label>
                                <br/>
                                <em className="text-muted">* You can select file to upload</em>
                                &nbsp;&nbsp;
                                {/*<span style={{display: "none"}} id="uploadingLoader"/>*/}
                                {uploadDeductionLoading && (
                                    <div className="mt-2 mb-2 p-1">
                                        <Spinner
                                            size="small"
                                            message="Uploading File....."
                                            line-fg-color="#64c3c2"
                                        />
                                    </div>

                                )}
                                {deductionMessage !== '' && !uploadDeductionLoading && (
                                    <span className="text-success">
                                        <br/>File Saved&nbsp;<i className="fa fa-check" />
                                    </span>
                                )}
                                <div>
                                    {deductionMessage === '' && !uploadDeductionLoading && (
                                        <label className="btn btn-sm btn-primary" htmlFor="my-file-selector">
                                            <input required
                                                   id="my-file-selector"
                                                   type="file"
                                                   name="deduction_form"
                                                   style={{display: "none"}}
                                                   accept=".pdf, .docx, .doc"
                                                   onChange={handleDeductionFileChange}
                                            />
                                            <i className="fa fa-folder-open"/>&nbsp;&nbsp;
                                            Browse
                                        </label>
                                    )}
                                    <div className="p-3"/>
                                    {deductionMessage && (
                                        <span className="form-control text-muted" id="upload-file-info">{deductionMessage}</span>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="p-3"/>

                    </div>
                );
            default:
                return 'Unknown step';
        }
    }

    /**
     *   end stepper form
     */

    const handleChange = name => ({ target: { value } }) => {
        if(name === "paymentMethod" && value === "CASH"){
            setShowBankDetails(false);
            setShowMobileDetails(true);
        }else if(name === "paymentMethod" && value === "DEBIT_ORDER"){
            setShowMobileDetails(false);
            setShowBankDetails(true);
        }else if (name === "paymentMethod" && value === "STOP_ORDER") {
            setShowMobileDetails(false);
            setShowBankDetails(false);
        }
        setPolicy({ ...policy, [name]: value })
    }

    const [policyProduct, setPolicyProduct] = useState({});
    const handleChangePolicyProduct = name => ({target: {value}}) => {
        let prod = JSON.parse(value)
        console.log(prod);
        setPolicyProduct({
            ...policyProduct,
            "package_id": productId,
            "sum_assured": prod.sum_assured,
            "premium": prod.monthly_investments_premium,
            "product_id": prod.product_id
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoadingPolicy(true);
        console.log("policy: ", policy);

        if (policy.branch === undefined) {
            policy.branch = ""
        }
        if (policy.bankName === undefined) {
            policy.bankName = ""
        }
        if(policy.accountNumber === undefined){
            policy.accountNumber = ""
        }
        if(policy.accountName === undefined){
            policy.accountName = ""
        }
        if (policy.debitDate === undefined) {
            policy.debitDate = ""
        }
        if (policy.mobileNumber === undefined) {
            policy.mobileNumber = ""
        }
        if (policy.mobileAccountName === undefined) {
            policy.mobileAccountName = ""
        }
        let cDate;
        if (commencementDate.day < 10) {
            console.log(commencementDate.year + '-' + commencementDate.month + '-0' + commencementDate.day);
            cDate = commencementDate.year + '-' + commencementDate.month + '-0' + commencementDate.day
        } else {
            console.log(commencementDate.year + '-' + commencementDate.month + '-' + commencementDate.day);
            cDate = commencementDate.year + '-' + commencementDate.month + '-' + commencementDate.day;
        }

        let data = {
            "policy_holder_id": JSON.parse(localStorage.getItem('policyHolderId')),
            "product_id": policyProduct.product_id,
            "package_id": policyProduct.package_id,
            "payment_method": policy.paymentMethod,
            "payment_frequency": policy.paymentFrequency,
            "premium_payer": policy.premiumPayer,
            "bank_name": policy.bankName,
            "branch": policy.branchName,
            "account_number": policy.accountNumber,
            "account_name": policy.accountName,
            "policy_currency": policy.currency,
            "industry": policy.industry,
            "mobile_number": policy.mobileNumber,
            "mobile_account_name": policy.mobileAccountName,
            "application_form": policy.application_form,
            "deduction_form": policy.deduction_form,
            "agent_id": policy.agentId,
            "financial_advisor_reference": policy.agentId,
            "commencement_date": cDate,
            "sum_assured": policyProduct.sum_assured,
            "premium": policyProduct.premium,
            "user_id": user.id
        }

        console.log("data: ", data);
        setLoadingPolicy(false);

        SavingsPolicyService.allocatePlan(data)
            .then(res => {
                console.log(res);
                if (res.status === 400) {
                    setLoadingPolicy(false);
                    toast.warning('Wrong inputs! Please verify your details', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else if (res.status === 500) {
                    setLoadingPolicy(false);
                    toast.warning('Operation Failed', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
                setLoadingPolicy(false);
                //store policyNumber
                localStorage.setItem("policyId", JSON.stringify(res.data.policy.id));
                localStorage.setItem("policyNumber", JSON.stringify(res.data.policy.policy_number));
                localStorage.setItem("policy", JSON.stringify(res.data.policy));
                //navigate to add beneficiaries
                history.push('/view-policy');
            })
            .catch(err => {
                setLoadingPolicy(false);
                toast.warning('Operation Failed', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                console.log(err);
            });
    }

    const [productId, setProductId] = useState(null);
    const [user, setUser] = useState(null);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setInitialLoading(true)
        setProductsLoading(true)
        const user = JSON.parse(localStorage.getItem('user'));
        console.log(user);
        setUser(user);
        let date = moment()
        const defaultValue = {
            year: date.year(),
            month: date.month() + 1,
            day: 1
        };
        console.log(date.date())
        setCommencementDate(defaultValue)
        setShowBankDetails(false);
        setShowMobileDetails(false);
        const pHId = JSON.parse(localStorage.getItem('policyHolderId'));
        setPolicyHolderId(pHId);
        console.log("data: ", pHId);
        AgentService.getAllAgents().then(response => {
            // console.log('ALLAgents', response.agents);
            setAgents(response.agents);
            SettingsService.getIndustries().then(response => {
                console.log(response);
                if (response === undefined) {
                    setIndustries([])
                    setInitialLoading(false);
                }
                let industries = response.data.data;
                setIndustries(industries);
                setInitialLoading(false);

                //   console.log();                                                                                        );
            }).catch(err => {
                console.log(err);
                setIndustries([])
                setInitialLoading(false);
            });

        }).catch(err => {
            console.log(err);
            SettingsService.getIndustries().then(response => {
                console.log(response);
                if (response === undefined) {
                    setIndustries([])
                    setInitialLoading(false);
                }
                let industries = response.data.data;
                setIndustries(industries);
                setInitialLoading(false);

                //   console.log();                                                                                        );
            }).catch(err => {
                console.log(err);
                setIndustries([])
                setInitialLoading(false);
            });
        });

        ProductsService.getAllProducts().then(response => {
            console.log('ALLProducts', response.data.products);
            response.data.products.map((product,i) => {
                if (product.name === 'SAVINGS'){
                    setProductId(product.id);
                    SavingsService.getAllSavingsProducts(product.id)
                        .then(response => {
                            if(response.data.packages.length > 0){
                                console.log("products: ", response.data.packages);
                                setProducts(response.data.packages);
                                setProductsLoading(false)
                            }else{
                                console.log("products: ", response);
                                setProducts([])
                                setProductsLoading(false)
                            }
                        }).catch(err => {
                        console.log(err);
                        setProductsLoading(false)
                    })
                }
            })
        })

    }, []);

    return(
        <div>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link className="anchor text-primary" to={'/view-policy-holder'}>
                                <i className="fa fa-backward"/> BACK
                            </Link>    &nbsp;|
                            ALLOCATE SAVINGS POLICY
                        </ul>
                        <div className="row mt">
                            <div className="col-lg-12">
                                <div className="card">
                                    {loadingPolicy && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="medium"
                                                message="Allocating Policy,Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>

                                    )}
                                    {initialLoading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="medium"
                                                message="Preparing Form,Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>

                                    )}
                                    {!loadingPolicy && !initialLoading && (
                                        <form id="policyholderData" onSubmit={handleSubmit} autoComplete="off">
                                            <div id="form-style">
                                                <h4>Fill In Policy Details</h4>
                                                <div className="row mt">
                                                    <div className="col-lg-12">
                                                        <div className={classes.root}>
                                                            <Stepper activeStep={activeStep} orientation="vertical">
                                                                {steps.map((label, index) => (
                                                                    <Step key={label}>
                                                                        <StepLabel>{label}</StepLabel>
                                                                    <StepContent>
                                                                        <Typography>{getStepContent(index)}</Typography>
                                                                        <div className={classes.actionsContainer}>
                                                                            <div>
                                                                                <Button
                                                                                    disabled={activeStep === 0}
                                                                                    onClick={handleBack}
                                                                                    className="btn btn-secondary btn-sm"
                                                                                >
                                                                                    <i className="fa fa-backward"/>&nbsp;&nbsp;Back
                                                                                </Button>
                                                                                {activeStep === steps.length - 1 ? (
                                                                                    <Button variant="contained" color="primary"
                                                                                            onClick={handleSubmit}
                                                                                            className="btn btn-primary btn-sm ml-2 ld-ext-right">
                                                                                        Proceed &nbsp;<i className="fa fa-send"/>
                                                                                    </Button>
                                                                                ) : (
                                                                                    <Button variant="contained" color="primary"
                                                                                            onClick={handleNext}  className="btn ml-2 btn-primary btn-sm ld-ext-right">
                                                                                        Next
                                                                                    </Button>
                                                                                )}

                                                                            </div>
                                                                        </div>
                                                                    </StepContent>
                                                                </Step>
                                                            ))}
                                                        </Stepper>
                                                        {activeStep === steps.length && (
                                                            <Paper square elevation={0} className={classes.resetContainer}>
                                                                <Typography>All steps completed - you&apos;re finished</Typography>
                                                                <Button onClick={handleReset} className={classes.button}>
                                                                    Reset Form
                                                                </Button>
                                                            </Paper>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )


}

export default AllocateSavingsPolicy;
